// Version : 0.0.1
// Author : VIGNESH
// LastEdit : VIGNESH
// Last ADD : REMOVED UNWANTED REDUX AND ADDED COMMENTS
// MODIFIED DATA : 07-12-2025

/* eslint-disable import/no-anonymous-default-export */
import BranchProfileReportActionTypes from './branch-profile-report.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	getBranchProfileReportResponse: null,
	getBranchProfileReportArr: [],
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/****************** FETCH BRANCH PROFILE REPORT START  *********************/
		case BranchProfileReportActionTypes.GET_BRANCH_PROFILE_REPORT_SUCCESS:
			return {
				...state,
				getBranchProfileReportResponse: action.payload,
				getBranchProfileReportArr: docodeHexResponse(
					action.payload,
					'FetchBranchProfileReportKey',
				),
			};

		case BranchProfileReportActionTypes.GET_BRANCH_PROFILE_REPORT_FAILURE:
			return { ...state, getBranchProfileReportResponse: action.payload };

		case BranchProfileReportActionTypes.GET_BRANCH_PROFILE_REPORT_RESPONSE_CHANGED:
			return { ...state, getBranchProfileReportResponse: null };
		/****************** FETCH BRANCH PROFILE REPORT END  *********************/
		default:
			return state;
	}
};
